import React from "react";
import { useBloc } from "@blac/react";
import simpleRnd from "lib/simpleRnd";
import { useEffect, useMemo } from "react";
import { Form } from "react-aria-components";
import { z } from "zod";
import AutoFormBloc, {
  AutoFormProps,
  AutoFormValidateOptions
} from "./AutoFormBloc";
import AutoFormContext from "./AutoFormContext";

export default function AutoForm<S extends z.ZodObject<z.ZodRawShape>>(
  props: AutoFormProps<S>
) {
  const autoFormId = useMemo(() => simpleRnd(), []);
  const contextId = props.contextId ?? autoFormId;
  const formRef = React.useRef<HTMLFormElement>(null);

  const [{ validationErrors }, { handleSubmit, setSchema }] = useBloc(
    AutoFormBloc<S>,
    {
      id: contextId,
      props
    }
  );

  useEffect(() => {
    setSchema(props);
  }, [props.schema]);

  const validateOptions: AutoFormValidateOptions = {
    focusInputOnError: true,
    formEl: formRef.current
  };

  return (
    <AutoFormContext.Provider value={contextId}>
      <Form
        onSubmit={(e) => handleSubmit(e, validateOptions)}
        validationBehavior="aria"
        validationErrors={validationErrors}
        ref={formRef}
      >
        {props.children}
      </Form>
    </AutoFormContext.Provider>
  );
}
